'use strict';

var React = require('react');

var SvgRemoveProductMajor = function SvgRemoveProductMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 1h6a2 2 0 0 1 2 2v6c0 .339 0 1-1.5 1h-1.5a6 6 0 0 0-6 6v2c0 1.17-.91 1.214-2 .83a2.988 2.988 0 0 1-1.121-.708l-5-5a3 3 0 0 1 0-4.243l7-7a2.991 2.991 0 0 1 2.121-.879Zm3 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm5 5.996a1 1 0 1 1 0 2h-5.998a1 1 0 1 1 0-2h5.998Z"
  }));
};

exports.SvgRemoveProductMajor = SvgRemoveProductMajor;
